import React from 'react';

const DisplayImage = props => {
    const { image, onImageUpload } = props;

    return (
        <div className="oi-uploader">
            <img className="oi-uploader__display" src={image} alt=" " />

            <label className="oi-uploader__upload">
                <input type="file" name="myImage" onChange={onImageUpload} className="oi-uploader__input" />

                {!image && <div>+</div>}
                {image && <div className="oi-uploader__change-image">+</div>}
            </label>
        </div>
    );
};

export default DisplayImage;
